import React, { FC, ReactNode } from 'react';
import { BaseLayout } from '../BaseLayout';

interface MainLayoutProps {
  children?: ReactNode;
  mainColor?: string;
  hasHeader?: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({ children, mainColor, hasHeader = true }) => {
  return <BaseLayout hasHeader={hasHeader} mainColor={mainColor}>{children}</BaseLayout>;
};

export default MainLayout;

export const getMainLayout = (page: ReactNode) => {
  return <MainLayout hasHeader={false}>{page}</MainLayout>;
};
